module.exports = __webpack_public_path__ + "img/1.1d196860.svg";